
import * as angular from "angular";
import { PrintService } from "@services/print.service";
import "./printElement.scss";

export class PrintElementDirective implements angular.IDirective {

    restrict = 'A';

    printSection: HTMLElement;

    static $inject = ["printService"];

    constructor(private readonly printService: PrintService) {
    }

    link(scope: angular.IScope, element: angular.IAugmentedJQuery, attrs: angular.IAttributes, ngModel: angular.INgModelController) {
        element.bind("click", (evt) => {
            evt.preventDefault();
            
            this.printService.print(attrs["printElement"]);
        });
    }

    static factory(): angular.IDirectiveFactory {
        const directive = (printService: PrintService) => new PrintElementDirective(printService);

        directive.$inject = ["printService"];

        return directive;
    }
}
